import type {
  CoreApiRequestPayload,
  CoreItem,
  CoreItemPayload,
} from '@flecto/types'

import { api } from '../../../services/api'

export type CreateItemOptions = {
  enable?: boolean
}

/**
 * Create a new item.
 *
 * @endpoint POST /api/saas/me/items
 * @scope saas
 * @see https://flecto.dev/api-4724232
 */

export async function createItem(
  item: CoreItemPayload,
  options?: CreateItemOptions
): Promise<CoreItem> {
  const body: CoreApiRequestPayload<CoreItemPayload> = {
    data: {
      type: 'item',
      attributes: item,
    },
  }

  const response = await api.post('/api/saas/me/items', body, {
    params: options,
  })

  return response.data.item
}
